export default "__VITE_ASSET__De59EoSY__"